import { configureStore } from "@reduxjs/toolkit";
import { analyticsManager } from "../reducers/analytics.slice";

export default configureStore({
  reducer: {
    analytics: analyticsManager,
  },
});
